export const isValidString = (testString) => {
	if (typeof testString !== 'string') return false;
	if (testString.trim().length === 0) return false;
	return true;
};
